import { useMemo, useState } from "react";
import { Card, Stack, TextField, MenuItem, Button } from "@mui/material";

export default function NuevaTareaForm({ leads, onAdd, onClose }) {
  const [hasDescription, setHasDescription] = useState(false);
  const options = useMemo(() => leads.filter(l => l.etapa !== "inscrito" && l.etapa !== "perdido").map(l => <MenuItem key={l.id} value={l.id}>{l.nombre}</MenuItem>), [leads]);
  const submit = e => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    const descripcion = String(data.get("descripcion") || "").trim();
    if (!descripcion) return;
    onAdd({ descripcion, leadId: data.get("leadId") || "", tipo: data.get("tipo") || "", fechaProgramada: data.get("fechaProgramada") || "" });
    onClose();
  };
  return <Card component="form" onSubmit={submit} variant="outlined" sx={{ mb: 2, p: 2 }}>
    <Stack spacing={2}>
      <TextField name="descripcion" label="Descripción de la tarea" defaultValue="" onChange={e => setHasDescription(Boolean(e.target.value.trim()))} fullWidth autoFocus size="small" />
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        <TextField name="tipo" label="Tipo" defaultValue="" select size="small" sx={{ minWidth: 140 }}>
          <MenuItem value="">General</MenuItem><MenuItem value="visita">Visita</MenuItem><MenuItem value="seguimiento">Seguimiento</MenuItem><MenuItem value="llamada">Llamada</MenuItem>
        </TextField>
        <TextField name="leadId" label="Lead asociado" defaultValue="" select size="small" sx={{ minWidth: 200 }}>
          <MenuItem value="">Ninguno</MenuItem>{options}
        </TextField>
        <TextField name="fechaProgramada" label="Fecha" defaultValue="" type="date" InputLabelProps={{ shrink: true }} size="small" />
        <Button variant="contained" size="small" type="submit" disabled={!hasDescription}>Agregar</Button>
        <Button size="small" onClick={onClose}>Cancelar</Button>
      </Stack>
    </Stack>
  </Card>;
}
